// Shared by components/Form.tsx and app/api/sendEmail/route.tsx: the browser
// names its inputs with these keys and checks the files for a quick answer,
// the server reads the same keys and enforces the same limits.
import type { FormFieldStoryblok } from "@/component-types-sb";
import { createSlug } from "@/lib/utils";

export const MAX_FILES_PER_FIELD = 3;
export const MAX_FILE_SIZE_MB = 4;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const isPdf = (file: File) =>
  file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");

// The `name` attribute only has to be unique within this form (it's the key
// FormData collects values under), so fields sharing a label (e.g. two
// "Name" fields) get suffixed -2, -3, ... to avoid silently colliding.
export const fieldKeys = (fields: FormFieldStoryblok[]) => {
  const counts: Record<string, number> = {};
  return fields.map((field, index) => {
    const base = createSlug(field.name || "") || `field-${index}`;
    const count = (counts[base] = (counts[base] || 0) + 1);
    return count === 1 ? base : `${base}-${count}`;
  });
};
